import { render, staticRenderFns } from "./CourseNotes.html?vue&type=template&id=ce075bd6&scoped=true&external"
import script from "./CourseNotes.vue?vue&type=script&lang=js"
export * from "./CourseNotes.vue?vue&type=script&lang=js"
import style0 from "./CourseNotes.scss?vue&type=style&index=0&id=ce075bd6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce075bd6",
  null
  
)

export default component.exports